<template>
  <header class="header">
    <img class="header__logo" src="~@/assets/logo-unmsm.png" alt />
    <ul class="header-adm">
      <li><button class="button" @click="logout()">Cerrar Sesión</button></li>
      <li><Doubt class="doubt-show" /></li>
    </ul>   
  </header>
</template>

<script>
import { getSession, removeSession } from "@/services/session";
import { redirect } from "@/services/router";
import Doubt from "@/components/Doubt";

export default {
  methods: {
    logout() {
      let type = getSession()["type"];
      removeSession();
      if (type == 0) {
        redirect("login-admin");
      } else {
        redirect("login");
      }
    },
  },
  components: {
    Doubt,
  },
};
</script>

<style lang='scss' scoped>
.header {
  padding: 6px 10px 6px 0;
  height: 64px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  z-index: 100;
  //
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__logo {
    height: 100%;
  }
}

.header-adm {
  display: flex;
  align-items: center;
  padding-left: 0px;
}

.header-adm li {
  list-style: none;
}

.doubt-show {
  display: none;
}

@media only screen and (max-width: 1050px) {
  .doubt-show {
    display: block;
  }
}
</style>